module.exports = __webpack_public_path__ + "img/9788954616034.e5bdb74a.jpg";